var exports = {
  "r2": "EditGroupModal.module__iconSection___UzA3Qk",
  "go": "EditGroupModal.module__iconLabel___UzA3Qk",
  "zc": "EditGroupModal.module__iconContainer___UzA3Qk",
  "O2": "EditGroupModal.module__iconPreview___UzA3Qk",
  "Pz": "EditGroupModal.module__iconPlaceholder___UzA3Qk",
  "So": "EditGroupModal.module__iconPlaceholderIcon___UzA3Qk",
  "D_": "EditGroupModal.module__iconActions___UzA3Qk",
  "Rh": "EditGroupModal.module__iconButtonGroup___UzA3Qk",
  "m5": "EditGroupModal.module__iconError___UzA3Qk",
};

module.exports = exports;
